import { useMemo } from "react";

import { AssetManagerSingleCardWithTabsTemplate } from "../../../templates";
import { Button, Card, Column, Row, TogglePieChartKPI } from "../../../widget";
import { DealsClosed, SpendVsPredictedReturns } from "./components";
import { usePortfolio } from "./usePortfolio";

const Portfolio = (): JSX.Element => {
  const {
    tabsList,
    isLoading,
    dealStageChartData,
    dealTypeChartData,
    dealTypeOrStage,
    predictedReturns,
    plannedInvestment,
    dealsClosedChartData,
    onNewDealClick,
    setDealTypeOrStage,
  } = usePortfolio();

  const kpis = useMemo(
    () => (
      <Row>
        <Column span="4_half">
          {isLoading ? (
            <Card corners="rounded" padding="ml" height="100%">
              <p className="body01">Investment vs returns</p>
              <p className="body2 NoData">Loading...</p>
            </Card>
          ) : (
            <SpendVsPredictedReturns plannedInvestment={plannedInvestment} predictedReturns={predictedReturns} />
          )}
        </Column>
        <Column span={5}>
          <TogglePieChartKPI
            data={dealTypeOrStage === "By type" ? dealTypeChartData : dealStageChartData}
            title={`Deals ${dealTypeOrStage.toLowerCase()}`}
            toggleTabsList={[{ label: "By type" }, { label: "By stage" }]}
            currentTab={dealTypeOrStage}
            onChange={(value) => setDealTypeOrStage(value)}
          />
        </Column>
        <Column span="2_half">
          {isLoading ? (
            <Card corners="rounded" padding="ml" height="100%">
              <p className="body01">Deals closed</p>
              <p className="body2 NoData">Loading...</p>
            </Card>
          ) : (
            <DealsClosed dealsClosedChartData={dealsClosedChartData} />
          )}
        </Column>
      </Row>
    ),
    [
      isLoading,
      dealTypeOrStage,
      dealTypeChartData,
      dealStageChartData,
      plannedInvestment,
      predictedReturns,
      dealsClosedChartData,
      setDealTypeOrStage,
    ]
  );

  const newDealButton = (): JSX.Element | undefined => (
    <Button text="New deal" onClick={onNewDealClick} variant="tertiary" />
  );

  return AssetManagerSingleCardWithTabsTemplate({
    activeElement: "Portfolio",
    pageTitle: "Pipeline",
    tabsList,
    carousel: kpis,
    backButtonText: undefined,
    handleBackClick: undefined,
    quickActions: newDealButton(),
  });
};

export default Portfolio;
